import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import SupportersSection from '../components/SupportersSection';
import HowConectarHelpsSection from '../components/HowConectarHelpsSection';
import AIDrawingSpotlight from '../components/AIDrawingSpotlight';
import RoutinesSpotlightSection from '../components/RoutinesSpotlightSection';
import GamesSpotlightSection from '../components/GamesSpotlightSection';
import MusicSpotlightSection from '../components/MusicSpotlightSection';
import MonitoringSection from '../components/MonitoringSection';
import AudienceRow from '../components/AudienceRow';
import StatsSection from '../components/StatsSection';
import FAQPreviewSection from '../components/FAQPreviewSection';
import FinalCTASection from '../components/FinalCTASection';
import Footer from '../components/Footer';
import { ScrollReveal } from '../components/ScrollReveal';

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <ScrollReveal><SupportersSection /></ScrollReveal>
        <ScrollReveal><HowConectarHelpsSection /></ScrollReveal>
        <ScrollReveal><AIDrawingSpotlight /></ScrollReveal>
        <ScrollReveal><RoutinesSpotlightSection /></ScrollReveal>
        <ScrollReveal><GamesSpotlightSection /></ScrollReveal>
        <ScrollReveal><MusicSpotlightSection /></ScrollReveal>
        <ScrollReveal><MonitoringSection /></ScrollReveal>
        <ScrollReveal><AudienceRow /></ScrollReveal>
        <ScrollReveal><StatsSection /></ScrollReveal>
        <ScrollReveal><FAQPreviewSection /></ScrollReveal>
        <ScrollReveal><FinalCTASection /></ScrollReveal>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
